import { NavigationContainer } from "@react-navigation/native";
import React, { useContext } from "react";
import {
  AUTH_SCREEN_NAMES,
  DASHBOARD_SCREENS,
  SCREEN_PRIVACY,
  SCREEN_RESET_PASSWORD,
} from "web/constants";
import AuthStack from "webComponentsAuth/AuthStack.component";
import Dashboard from "webComponentsScreens/dashboard/Dashboard.component";
import { AuthContext } from "webContext/Auth.context";

export default function AuthNavigation() {
  const { userToken, logout, authInitializing } = useContext(AuthContext);

  if (authInitializing) {
    return null;
  }

  const authRoutes = Object.fromEntries(
    Object.keys(AUTH_SCREEN_NAMES).map((screen) => [screen, screen]),
  );

  const dashboardRoutes = Object.fromEntries(
    Object.keys(DASHBOARD_SCREENS).map((screen) => [screen, screen]),
  );

  return (
    <NavigationContainer
      key={userToken ? "authenticated" : "unauthenticated"}
      linking={{
        config: {
          screens: userToken
            ? {
                ...dashboardRoutes,
                [SCREEN_PRIVACY]: SCREEN_PRIVACY,
              }
            : {
                ...authRoutes,
                [SCREEN_RESET_PASSWORD]: `${SCREEN_RESET_PASSWORD}/:userId/:key`,
              },
        },
      }}
    >
      {userToken ? <Dashboard logout={logout} /> : <AuthStack />}
    </NavigationContainer>
  );
}
